import { Component, ChangeDetectionStrategy, inject } from "@angular/core";
import { WidgetParent } from "../../class/widget-parent";
import { ComponentAdapterFactory } from "../../class/adapters/component-adapter-factory";
import { SmartPaletteGeneral } from "../../class/smart-palette";
import { IconHelper } from "../../class/icon-helper";
import { ComponentAdapterScenario } from "../../class/adapters/component-adapter-scenario";
import { AlertService } from "src/service/alert.service";
import { IonButton, IonIcon } from "@ionic/angular";
import { SmartComponentSpinnerComponent } from "../smart-component-spinner/smart-component-spinner.component";
import { ErrorLoadingWidgetComponent } from "../error-loading-widget/error-loading-widget.component";

@Component({
    selector: "app-widget-scenario",
    templateUrl: "./widget-scenario.component.html",
    styleUrls: ["./widget-scenario.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonButton, IonIcon, SmartComponentSpinnerComponent, ErrorLoadingWidgetComponent]
})

/**
 * Scenario entry component
 */
export class WidgetScenarioComponent extends WidgetParent<ComponentAdapterScenario> {
  private _iconScenarioPlay = "";
  private _iconScenarioStop = "";

  private readonly _alertService = inject(AlertService);

  public iconScenarioState: string = "";
  public isScenarioRunning: boolean = false;

  constructor() {
    super();


    this._iconScenarioPlay = IconHelper.getIconsForScenarioComponent().play;
    this._iconScenarioStop = IconHelper.getIconsForScenarioComponent().stop;

    this.iconScenarioState = this._iconScenarioPlay;
  }

  /**
   * Update the running state and the icon shown by the widget
   * @param isRunning whether the scenario is currently running
   */
  private setScenarioRunningState(isRunning: boolean): void {
    this.isScenarioRunning = isRunning;
    this.iconScenarioState = isRunning
      ? this._iconScenarioStop
      : this._iconScenarioPlay;
  }

  /**
   * When the button is clicked execute scenario
   */
  public onClickToggleScenario(): void {
    this.toggleScenario();
  }

  /**
   * Play or stop the scenario depending on its current running state.
   * Ask the user for confirmation before sending the command via mqtt.
   */
  private async toggleScenario(): Promise<void> {
    const commandAddress = this.isScenarioRunning
      ? this.componentAdapter.StopScenarioAddress
      : this.componentAdapter.ExecuteScenarioAddress;

    if (!commandAddress) {
      return;
    }

    const confirmMessage = this.isScenarioRunning
      ? this._translateService.instant("dictionary.scenarioConfirmStop")
      : this._translateService.instant("dictionary.scenarioConfirmExecute");

    const canExecuteCommand: boolean =
      await this._alertService.presentAlertConfirmOrDismiss(
        this._translateService.instant("dictionary.scenarioConfirmTitle"),
        "",
        confirmMessage
      );

    if (canExecuteCommand) {
      this.sendAddressCommand(
        commandAddress.instanceGUID,
        commandAddress.address,
        "1"
      );
    }
  }

  protected setWidgetSmartPalette(): SmartPaletteGeneral {
    let widgetSmaertPalette = new SmartPaletteGeneral();

    return widgetSmaertPalette;
  }

  protected onComponentLoad(): void { }

  protected onSmartComponentErrorLoading(): void { }

  protected onComponentDestroy(): void { }

  protected onSmartComponentSuccessLoaded(): void | boolean {
    const factory = new ComponentAdapterFactory();
    this.componentAdapter = factory.createComponentAdapter(
      this._listSmartComponentSkills,
      ComponentAdapterScenario
    );

    this.titleWidget = this.componentAdapter.Name;

    //If component title is empty show error loading component
    if (!this.titleWidget) {
      return this._errorLoading = true;
    }
  }

  protected onAddressValueChange(
    instanceGUID: string,
    address: string,
    value: string
  ): void {
    if (this.componentAdapter.RunningStateAddress) {
      if (
        instanceGUID === this.componentAdapter.RunningStateAddress.instanceGUID &&
        address === this.componentAdapter.RunningStateAddress.address
      ) {
        this.setScenarioRunningState(value === "1");
      }
    }
  }
}
